<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Stores loading requests')"
          :description="$t('From here you can control stores loading operations')"
        />
        <indexTable
          :searchText="$t('Search for stores loading operations')"
          :emptyTableText="$t('There are no store loading operations!')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('stores_orders_show')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Pending'), value: 0 },
            { title: $t('Loaded'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Operation'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'store_id',
              title: $t('Store name'),
              type: 'link',
              to: 'store',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('The date of the operation'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('Description'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Pending'), value: 0, color: 'dark' },
                { title: $t('Loaded'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('stores_orders_edit')
                },
                {
                  name: 'approveMoveStore',
                  role: $checkRole('stores_transfers_add'),
                  title: $t('Confirm loading'),
                  icon: 'suitcase'
                },

                {
                  name: 'delete',
                  role: $checkRole('stores_orders_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/storesOrders'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
